/**
 * Stops the loading shimmer on a media frame once its image has settled.
 *
 * The shimmer is pure CSS on the frame's ::before, sitting BEHIND the image.
 * The image is never hidden: it paints over the shimmer the moment it
 * arrives. That matters on the product page, where the main photo is the
 * Largest Contentful Paint element; hiding it and fading it in would delay the
 * very metric a loading state is supposed to help.
 *
 * So this script does not reveal anything. It switches the animation off once
 * there is nothing left to wait for - loaded, or failed. Without it a broken
 * image would shimmer forever, and a loaded one would keep animating
 * invisibly behind the photo.
 *
 * Renders no UI, formats nothing, never logs.
 */
(function () {
  'use strict';

  if (window.__bunzShimmer) return;
  window.__bunzShimmer = true;

  function settle(frame, ok) {
    frame.classList.add(ok ? 'is-loaded' : 'is-error');
  }

  function watch(frame) {
    var img = frame.querySelector('img');
    if (!img) { settle(frame, true); return; }
    // complete is true for a broken image as well; naturalWidth tells them apart
    if (img.complete) { settle(frame, img.naturalWidth > 0); return; }
    img.addEventListener('load', function () { settle(frame, true); }, { once: true });
    img.addEventListener('error', function () { settle(frame, false); }, { once: true });
  }

  function init() {
    var frames = document.querySelectorAll('.media-shimmer');
    for (var i = 0; i < frames.length; i++) watch(frames[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // cards swapped in by the filters (facets.js); re-running is harmless, a
  // settled frame just gets its class again
  document.addEventListener('bunz:content-updated', init);
})();
